<template lang="pug">
div
  login
  forgotPassword
  qrcode
  #content.content-wrapper
    .content-right
      .header
        .container
          .menu
            img(src='images/menu.png')
          .side-menu
            .side-logo
              //- router-link(to="/")
              a(href="javascript:void(0);" @click="redirect('all')")
                img(src='images/logo.png')
            .side-language
              language
              //- country
            //- ul
            //-   template(v-for="item in leftMenu")
            //-     li(:class="gameMenuSelected == item ? 'active' : ''")
            //-       a(href="javascript:void(0);" @click="redirect(item)")
            //-         .menu-icon
            //-           img(:src="'images/menu/' + item + '.png'")
            //-         .menu-icon-active
            //-           img(:src="'images/menu/' + item + '-active.png'")
            //-         .menu-text {{ item == 'promo' ? $tc('ui.' + item, 1) : $t('ui.' + item) }}
            .bottom-menu
              ul
                template(v-for="item in leftMenu")
                  li.member(:class="gameMenuSelected == item ? 'active' : ''")
                    a(href="javascript:void(0);" @click="redirect(item)")
                      .bottom-menu-icon
                        img(:src="'images/menu/' + item + '.png'")
                      .bottom-menu-active
                        img(:src="'images/menu/' + item + '-active.png'")
                      .bottom-menu-text {{ item == 'promo' ? $tc('ui.' + item, 1) : $t('ui.' + item) }}
                template(v-if="accountGroup == 'MU'")
                  li.member(:class="gameMenuSelected == 'promo' ? 'active' : ''")
                    router-link(to="/promo")
                      .bottom-menu-icon
                        img(:src="'images/menu/promo.png'")
                      .bottom-menu-active
                        img(:src="'images/menu/promo-active.png'")
                      .bottom-menu-text {{ $tc('ui.promo', 1) }}
              ul
                template(v-if="isLoggedIn")
                  template(v-for="menu in memberMenu")
                    li.member(:class="memberMode == menu ? 'active' : ''" @click="setMode(menu)")
                      template(v-if="menu != 'qrcode'")
                        router-link(:to='"/" + menu')
                          .bottom-menu-icon
                            img(:src="'images/menu/' + menu + '.png'")
                          .bottom-menu-active
                            img(:src="'images/menu/' + menu + '-active.png'")
                          .bottom-menu-text {{ $t('ui.' + menu) }}
                      template(v-else)
                        a(href='javascript:void(0);' data-bs-toggle='modal' data-bs-target='#modal-qrcode')
                          .bottom-menu-icon
                            img(:src="'images/menu/' + menu + '.png'")
                          .bottom-menu-active
                            img(:src="'images/menu/' + menu + '-active.png'")
                          .bottom-menu-text {{ $t('ui.' + menu) }}
                //- li.menu-mission
                //-   //- router-link(to="/mission")
                //-   a(href="javascript:void(0);")
                //-     .bottom-menu-icon
                //-       img(src='images/menu/mission.png')
                //-     .bottom-menu-text {{ $t('ui.mission') }}
                //- li.menu-event
                //-   //- router-link(to="/event")
                //-   a(href="javascript:void(0);")
                //-     .bottom-menu-icon
                //-       img(src='images/menu/event.png')
                //-     .bottom-menu-text {{ $t('ui.event') }}
                //- li.menu-tournament
                //-   //- router-link(to="/tournament")
                //-   a(href="javascript:void(0);")
                //-     .bottom-menu-icon
                //-       img(src='images/menu/tournament.png')
                //-     .bottom-menu-text {{ $t('ui.tournament') }}
          .overlay
          .logo
            router-link(to="/")
              img(src='images/logo.png')
          .header-right(:class="isLoggedIn ? 'logged-in' : ''")
            .select-language
              language
              //- country
            .text-right
              template(v-if="!isLoggedIn")
                .btn-header
                  div
                    a(href='javascript:void(0);' data-bs-toggle='modal' data-bs-target='#modal-login')
                      .btn-main.btn-login
                        | {{ $t('ui.login') }}
                        i.fa-solid.fa-right-to-bracket.ms-1
                  //- .forgot-header
                  //-   a(href='javascript:void(0);' data-bs-toggle='modal' data-bs-target='#modal-forgot-password')
                  //-     .btn-main.btn-login
                  //-       | {{ $t('ui.forgot_password') }}
                  //-       i.fa-solid.fa-key.ms-1
                .forget-password-text 
                 a(href='javascript:void(0);' data-bs-toggle='modal' data-bs-target='#modal-forgot-password') {{ $t('ui.forgot_password') }}?
              template(v-else)
                .btn-header
                  .player-wrapper
                    template(v-if="!loading")
                      .player-balance {{ $t('ui.balance') }}: {{ $numeral(balance).format("0,0.00") }}
                    template(v-else)
                      .player-balance
                        .i.fas.fa-sync.fa-spin
                    .player-name {{ $t('ui.welcome') }}, {{ displayName }}
                    //- .player-name.small {{ currentTime }}
                  router-link(to="/deposit")
                    .btn-main.btn-deposit(@click="setMode('deposit')")
                      | {{ $t('ui.deposit') }}
                      i.fa-solid.fa-circle-dollar-to-slot.ms-1
                  a(href='javascript:void(0);' @click="logout()")
                    .btn-logout
                      i.fa-solid.fa-right-from-bracket
      router-view
      footerMenu
      footerProvider
</template>

<script>
import config from "@/config"
import QRCode from 'qrcode'

export default{
  components: {
    login: () => import("@/components/_login"),
    forgotPassword: () => import("@/components/_forgotPassword"),
    qrcode: () => import("@/components/_qrcode"),
    language: () => import("@/components/_language"),
    country: () => import("@/components/_country"),
    footerMenu: () => import("@/components/_footerMenu"),
    footerProvider: () => import("@/components/_footerProvider"),
  },
  data() {
    return {
      loading: false,
      // leftMenu: ['hot','sports','slot','casino','fish','promo','download'],
      leftMenu: ['hot','sports','slot','casino'],
      refreshBalance: null, 
      favList: []
    }
  },
  computed: {
		isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    accountGroup() {
      return this.$store.getters.accountGroup
    },
    getLanguage() {
      return this.$store.getters.language
    },
    balance() {
      return this.$store.getters.balance
    },
    displayName() {
      return this.$store.getters.username || this.$store.getters.accountID
    },
    gameMenuSelected() {
      return this.$store.getters.gameMenuSelected
    },
    memberMenu() {
      return this.accountGroup == 'WI' ? config.memberMenuWI : config.memberMenuMU
    },
    memberMode() {
      return this.$store.getters.memberMode;
    }
	},
  watch:{
    isLoggedIn(newVal, oldVal){
      if(newVal){
        this.getBalance()
        this.getMemberFavGame()
      }
    },
  },
  destroyed() {
    clearInterval(this.refreshBalance);
  },
  mounted(){
    // side menu
    if ($(window).width() < 1200) {
      $('.menu').click(function(){
        $('.side-menu').addClass('d-block');
        $('body').addClass("fixed");
        $('.overlay').show();
      });	
      
      $(".overlay").click(function() {
        $('.side-menu').removeClass('d-block');
        $('body').removeClass("fixed");
        $('.overlay').hide();
      }); 

      // $(".member").click(function() {
      //   $('.side-menu').removeClass('d-block');
      //   $('body').removeClass("fixed");
      //   $('.overlay').hide();
      // });
    }

    this.getBalance()
    this.refreshBalance = setInterval(() => {
      this.getBalance()
    }, 8000)
  },
  methods:{
    logout() {
      // $('.overlay').hide();
      // $('.left-wrapper').removeClass('d-block');
      // $('body').removeClass("fixed");
      this.$store
        .dispatch("user/logout")
        .then(() => {
          // set gamelist to all
          $('.categories .filter-content .grid-item').removeClass('d-none');
          this.$router.push("/").catch(error =>{})
        })
        .catch(err => {})
      
    },
    setGameMenu(game) {
      this.$store.dispatch("user/setGeneralMenuSelected", "")
      this.$store.dispatch("user/setMemberMode", "")

      if(!['download','promo'].includes(game)) {
        $('.categories-title').html(game);
        if(game == 'favorite') {
          $('.categories .filter-content .grid-item').addClass('d-none');
          $('.categories .filter-content .grid-item .icon-star.active').parent().removeClass('d-none');
        } else if (game == 'all') {
          $('.categories .filter-content .grid-item').removeClass('d-none');
        } else{
          $('.categories .filter-content .grid-item').addClass('d-none');
          $('.categories .filter-content .grid-item.filter-'+game).removeClass('d-none');
        }
      }
      this.$store.dispatch("user/setGameMenuSelected", game)
    },
    redirect(game) {
      if(this.$route.path == "/") {
        this.setGameMenu(game)
      } else {
        this.$router.push("/").then(() => {
          this.setGameMenu(game)
        })
      }
    },
    setMode(mode) {
      this.$store.dispatch("user/setGameMenuSelected", "")
      this.$store.dispatch("user/setGeneralMenuSelected", "")

      this.$store.dispatch("user/setMemberMode", mode)
    },
    getBalance(callback) {
      if (this.loading == true) return;
      if (this.isLoggedIn) {
        this.loading = true;
        let login_id = this.accountID
        let auth_token = this.sessionToken
        this.$store.dispatch("user/getBalance", { login_id, auth_token }).then(
          res => {
            this.loading = false;
            if (res.success) {
              if (callback) callback();
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                if (callback) callback();
              }
            }
          },
          err => {
            this.loading = false;
            if (this.$helpers.handleFeedback(err.status)) {
              if (callback) callback();
            }
          }
        );
      }
    },
    getMemberFavGame() {
      if (this.isLoggedIn) {
        this.loading = true
        let login_id = this.accountID
        let auth_token = this.sessionToken
        this.$store.dispatch("user/getMemberFavGame", { login_id, auth_token }).then(
          res => {
            this.loading = false
            if (res.success) {
              // console.log("getMemberFavGame", res.data)
            } else {
              this.$helpers.showDialog(this.$t("ui.cancel"), this.$t("message.list." + res.status), "error")
            }
          },
          err => {
            this.loading = false
            this.$helpers.showDialog(this.$t("ui.cancel"), this.$t("message.list." + err.status), "error")
          }
        );
      }
    }
  }
}
</script>